<template>
    <f7-list media-list>
      <li class="" v-for="inMessage in inMessages">
        <div class="item-content">
          <div class="item-inner">
            <div class="item-title-row">
              <div class="item-title">{{getNameLabelDirection(inMessage)}}</div>
              <div class="item-after">
                <span class="dashboardActionMontant">{{getSymbol(inMessage.dir)}} {{inMessage.amt}} €</span>
              </div>
            </div>
            <div>
              <div class="statusLabel">{{getDirection(inMessage.dir)}}</div>
              <div class="timeLabel">{{inMessage.reqstdExecDt | formatDate}}</div>
            </div>
          </div>
        </div>
      </li>
    </f7-list>
</template>

<script>
import {loadPage} from '@/helpers/routing'

export default {
  name: 'TransactionsList',
  props: ['inMessages', 'role'],
  data: () => {
    return {
      statusColor: 'blue',
      icon: 'help'
    }
  },
  methods: {
    getDirection (dir) {
      if ((this.role === 'creditor' && dir === '1') || (this.role === 'debtor' && dir === '0')) {
        return 'Money received'
      } else if ((this.role === 'creditor' && dir === '0') || (this.role === 'debtor' && dir === '1')) {
        return 'Money sent'
      } else {
        return ''
      }
    },
    getSymbol (dir) {
      if ((this.role === 'creditor' && dir === '1') || (this.role === 'debtor' && dir === '0')) {
        return '+'
      } else if ((this.role === 'creditor' && dir === '0') || (this.role === 'debtor' && dir === '1')) {
        return '-'
      } else {
        return ''
      }
    },
    getNameLabelDirection (inMessage) {
      if ((this.role === 'creditor' && inMessage.dir === '1') || (this.role === 'debtor' && inMessage.dir === '0')) {
        return 'From: ' + inMessage.dbNm
      } else if ((this.role === 'creditor' && inMessage.dir === '0') || (this.role === 'debtor' && inMessage.dir === '1')) {
        return 'To: ' + inMessage.crNm
      } else {
        return ''
      }
    },
    seeDetails (message, isReceived) {
      this.$engine.settings.set({clickedMessage: message})
      // this.$engine.settings.set({msgFromInbox: isReceived})
      const that = this
      if (message.dir === '0') {
        loadPage(that, {url: '/payments/transaction-details/0/'})
      } else if (message.dir === '1') {
        loadPage(that, {url: '/payments/transaction-details/1/'})
      }
      // if (message.isRead !== '1' && message.dir === '0') {
      //   this.updateToSeen(message.id)
      // }
    }
  }
}
</script>

<style>
.list-block {
  padding: 0px 0px 0px 0px;
  margin: 0px 0px 0px 0px;
}
.statusLabel {
  color: #878787;
  font-size: 11px;
  float: left;
  padding-top: 6px;
}
.timeLabel {
  color: #878787;
  float: right;
}
.dashboardActionMontant {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// DashboardList.vue?748fe1f7